export const validateTotpCode = (value: string): boolean => {
	const pattern = /^[0-9]{6}$/;
	return !!value.match(pattern);
};
